import { Controller, Post, Body, Req } from '@nestjs/common';
import { CertificationResponseModel, AllCertificationsResponse } from '@gtpl/shared-models/hrms';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ApiTags } from '@nestjs/swagger';
import { CertificationDTO } from './dto/certification.dto';
import { CertificationIdRequest } from './dto/certification.request';
import { CertificationsService } from './certifications.service';


@ApiTags('certifications')
@Controller('certifications')
export class CertificationsController {

    constructor(
        private service: CertificationsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ){}

    @Post('/createCertification')
    async createCertification(@Body() DTO: CertificationDTO, isUpdate: boolean = false): Promise<CertificationResponseModel>{
        try{
            return await this.service.createCertification(DTO, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CertificationResponseModel, error);
        }
    }

    @Post('/updateCertification')
    async updateCertification(@Body() DTO: CertificationDTO, isUpdate: boolean = false): Promise<CertificationResponseModel>{
        try{
            return await this.service.createCertification(DTO, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CertificationResponseModel, error);
        }
    }

    @Post('/getAllCertifications')
    async getAllCertifications(): Promise<AllCertificationsResponse>{
        try{
            return await this.service.getAllCertifications();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllCertificationsResponse, error);
        }
    }

    @Post('/getAllActiveCertifications')
    async getAllActiveCertifications(): Promise<AllCertificationsResponse>{
        try{
            return await this.service.getAllActiveCertifications();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllCertificationsResponse, error);
        }
    }

    @Post('/activateOrDeactivate')
    async activateOrDeactivate(@Body() req: CertificationIdRequest): Promise<CertificationResponseModel>{
        try{
            return await this.service.activateOrDeactivateCertification(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CertificationResponseModel, error);
        }
    }

    @Post('/getCertificationById')
    async getCertificationById(@Body() req: CertificationIdRequest): Promise<CertificationResponseModel>{
        try{
            return await this.service.getCertificationById(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CertificationResponseModel, error);
        }
    }
}
